

































import { Component, Prop, Vue } from 'vue-property-decorator'
import Icon from '@/components/Icon.vue'
import NavItem from '@/models/NavItem'
import { NavItemTypes } from '@/models/Types'

@Component({
  components: {
    Icon,
  },
})
export default class Header extends Vue {
  @Prop({ default: [] }) private navList?: NavItem[]
  @Prop() private isOpen: boolean = false

  // data
  title: string = 'Cabin Artists'

  // computed
  get navMainItems(): NavItem[] {
    return this.navList!.filter(item => item.type === NavItemTypes.MAIN)
  }

  get navSocialItems(): NavItem[] {
    return this.navList!.filter(item => item.type === NavItemTypes.SOCIAL_MEDIA)
  }

  get navClasses(): any {
    return [
      'button--nav',
      { 'button--nav--active': this.isOpen },
    ]
  }

  get headerClasses(): any {
    return [
      'header__nav',
      { 'header__nav--active': this.isOpen },
    ]
  }

  // methods
  toggleMenu() {
    this.$emit('toggleMenu')
  }
}
